import useDiscoveryDialog from '../hooks/useDiscoveryDialog';
import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import { homeAddress, homeKey, preferenceTypes } from '../services/assistantDiscovery';
import './AssistantDiscovery.css';
export function PreferencesPanel({
  profile,
  onSave,
  onClose
}) {
  const dialogRef=useDiscoveryDialog(true,onClose);
  const [draft, setDraft] = useState(profile);
  const labels = {
    must_haves: 'Must-haves',
    preferences: 'Preferences',
    dealbreakers: 'Dealbreakers'
  };
  return createPortal(<div className="discovery-overlay"><section ref={dialogRef} tabIndex={-1} className="discovery-dialog" role="dialog" aria-modal="true" data-assistant-surface="preferences" aria-label="Your home preferences">
    <button className="discovery-close" onClick={onClose} aria-label="Close preferences">×</button><h2>Your home preferences</h2><p>Saved in this browser for this agent’s website. Edit anything the assistant should remember.</p>
    <form onSubmit={e => {
        e.preventDefault();
        onSave(draft);
        onClose();
      }}>{preferenceTypes.map(type => <label key={type}>{labels[type]}<textarea value={(draft[type] || []).join('\n')} onChange={e => setDraft({
            ...draft,
            [type]: e.target.value.split('\n')
          })} placeholder="One preference per line" /></label>)}
    <div className="discovery-actions"><button type="button" onClick={() => {
            const empty = {
              must_haves: [],
              preferences: [],
              dealbreakers: []
            };
            setDraft(empty);
            onSave(empty);
          }}>Forget preferences</button><button type="submit">Save preferences</button></div></form>
  </section></div>, document.body);
}
export function ComparisonTray({
  homes,
  onRemove,
  onCompare,
  onClear,
  busy
}) {
  if (!homes.length) return null;
  return <div className="comparison-tray" aria-label="Homes selected for comparison"><div><strong>Compare homes · {homes.length}/3</strong><button onClick={onClear}>Clear</button></div><ol>{homes.map((home, index) => <li key={homeKey(home)}><span className="compare-letter">{String.fromCharCode(65 + index)}</span><span>{homeAddress(home)}</span><button onClick={() => onRemove(homeKey(home))} aria-label={`Remove ${homeAddress(home)} from comparison`}>×</button></li>)}</ol><button className="discovery-primary" disabled={homes.length < 2 || busy} onClick={onCompare}>{busy ? 'Loading details…' : 'Compare selected homes'}</button></div>;
}
export function ComparisonPanel({
  homes,
  onClose,
  onAsk,
  busy,
  answer
}) {
  const dialogRef=useDiscoveryDialog(true,onClose);
  const [question, setQuestion] = useState('Which home best matches my preferences?');
  const pick = (h, ...fields) => fields.map(f => h[f] ?? h.features?.[f] ?? h.location?.[f] ?? h.associations?.[f]).find(v => v !== null && v !== undefined && v !== '');
  const number = v => v === undefined ? 'Not listed' : Number.isFinite(Number(v)) ? Number(v).toLocaleString() : String(v);
  const rows = [['Price', h => {
    const v = pick(h, 'current_price', 'list_price', 'price');
    return v === undefined ? 'Not listed' : `$${number(v)}`;
  }], ['Bedrooms', h => number(pick(h, 'bedrooms_total', 'bedrooms'))], ['Bathrooms', h => number(pick(h, 'bathrooms_total_integer', 'bathrooms_total', 'bathrooms_full'))], ['Living area (sq ft)', h => number(pick(h, 'living_area', 'building_area_total'))], ['Year built', h => String(pick(h, 'year_built') ?? 'Not listed')], ['Lot (acres)', h => number(pick(h, 'lot_size_acres'))], ['HOA fee', h => {
    const v = pick(h, 'association_fee');
    return v === undefined ? 'Not listed' : `$${number(v)} ${pick(h, 'association_fee_frequency') || '(frequency not listed)'}`;
  }]];
  return createPortal(<div className="discovery-overlay"><section ref={dialogRef} tabIndex={-1} className="discovery-dialog comparison-dialog" role="dialog" aria-modal="true" data-assistant-surface="comparison" aria-label="Compare homes"><button className="discovery-close" aria-label="Close comparison" onClick={onClose}>×</button><h2>Your homes, side by side</h2><p>Current listing facts. Missing details are marked for your agent to confirm.</p><p className="comparison-scroll-hint">Swipe the table sideways to see every home.</p><div className="comparison-scroll"><table><thead><tr><th>Feature</th>{homes.map((home, i) => <th key={homeKey(home)}><span className="compare-letter">{String.fromCharCode(65 + i)}</span>{homeAddress(home)}</th>)}</tr></thead><tbody>{rows.map(([title, value]) => <tr key={title}><th>{title}</th>{homes.map(home => <td key={homeKey(home)}>{value(home)}</td>)}</tr>)}</tbody></table></div>{answer && <p className="discovery-answer" role="status">{answer}</p>}<form onSubmit={e => {
        e.preventDefault();
        onAsk(question);
      }}><label>Ask about these homes<textarea rows={2} value={question} onChange={e => setQuestion(e.target.value)} /></label><button disabled={busy || !question.trim()} type="submit">{busy ? 'Thinking…' : 'Ask the assistant'}</button></form></section></div>, document.body);
}
